module.exports = __webpack_public_path__ + "static/media/spike-v4.c9a0aba3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/spike-v4.svg
// module id = 90
// module chunks = 0